export default [
  {
    path: '/applications-analytics',
    name: 'applications-analytics',
    component: () => import('@/views/applications-analytics/ApplicationsAnalyticsDashboard.vue'),
    meta: {
      title: 'Applications Analytics',
      requiresAuth: true,
      action: 'browes',
      resource: 'applications-analytics',
      pageTitle: 'Applications Analytics',
      breadcrumb: [
        {
          text: 'Applications Analytics',
          active: true,
        },
      ],
    },
  },
]
